export default __webpack_public_path__ + "static/media/glowingradiance.2a4c4c6e.png";